import actions from '@/core/store/processo-utilizacao/actions'
import mutations from '@/core/store/processo-utilizacao/mutations'
import state from '@/core/store/processo-utilizacao/state'

export default {
	actions,
	mutations,
	state,
}
